import React from 'react';
import { SvgProps } from '../../../models/components/svg';
import svgBaseClasses from '../../../constants/components/svg';

const LoadingIcon: React.FC<SvgProps> = ({ className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={className ?? svgBaseClasses}
            viewBox="0 0 360 360"
            fill="currentColor"
        >
            <path d="M180,1V61A119,119,0,1,1,61,180H1c0,98.7,80.3,179,179,179s179-80.3,179-179S278.7,1,180,1Z" />
        </svg>
    );
};

export default LoadingIcon;
